import { createModule } from 'saga-slice';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as reglementService from '../services/reglementService';

const reglementModule = createModule({
  name: "reglements",
  initialState: {
    list: [],
    totals: null,
    loading: false,
    error: null,
    totalElements: 0,
    totalPages: 0,
    pageNumber: 0,
    pageSize: 20,
    facturesImpayees: [],
    bonLivraisonsNonRegles: [],
    echeances: [],
    cautions: [],
    allocations:[],
    searchResults: {
      content: [],
      totalElements: 0,
      totalPages: 0,
      number: 0,
      size: 20
    },
    reglementById: null,
    allocationHistory: [],
  },
  reducers: {
    // List reglements
    listRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    listSuccess: (state, payload) => {
      state.loading = false;
      state.list = payload;
    },
    listEcheanceSuccess: (state, payload) => {
      state.loading = false;
      state.echeances = payload;
    },
    listCautionSuccess: (state, payload) => {
      state.loading = false;
      state.cautions = payload;
    },
    listFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    echeanceClient: (state) => {
      state.loading = true;
      state.error = null;
    },
    cautionClient: (state) => {
      state.loading = true;
      state.error = null;
    },

    // Create reglement
    createRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createSuccess: (state, { payload }) => {
      state.loading = false;
      state.list.push(payload);
    },
    createFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // Update reglement
    updateRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateSuccess: (state, { payload }) => {
      state.loading = false;

    },
    updateFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // Delete reglement
    deleteRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteSuccess: (state, { payload }) => {
      state.loading = false;
      state.list = state.list.filter(item => item.id !== payload);
    },
    deleteFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // Search reglements
    searchRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    totalsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    searchSuccess: (state, payload) => {
      state.loading = false;
      if (Array.isArray(payload)) {
        state.list = payload;
        state.totalElements = payload.length;
        state.totalPages = 1;
        state.pageNumber = 0;
        state.pageSize = payload.length || 20;
      } else {
        state.list = payload?.content || [];
        state.totalElements = payload?.totalElements ?? state.list.length;
        state.totalPages = payload?.totalPages ?? 1;
        state.pageNumber = payload?.number ?? payload?.pageNumber ?? 0;
        state.pageSize = payload?.size ?? state.pageSize;
      }
    },
    searchFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    totalsSuccess: (state, payload) => {
      state.loading = false;
      state.totals = payload;
    },
    totalsFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    allocationsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    allocationsSuccess: (state, payload) => {
      state.loading = false;
      state.allocations = payload;
    },
    allocationsFailure: (state) => {
      state.loading = false;
      state.error = null;
    },

    // Get reglements by client
    getReglementsByClientRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getReglementsByClientSuccess: (state, { payload }) => {
      state.loading = false;
      state.searchResults = payload;
    },
    getReglementsByClientFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // Get reglements by invoice
    getReglementsByInvoiceRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getReglementsByInvoiceSuccess: (state, { payload }) => {
      state.loading = false;
    },
    getReglementsByInvoiceFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    getReglementByIdRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getReglementByIdSuccess: (state, payload) => {
      console.log(payload)
      state.loading = false;
      state.reglementById = payload;
    },
    getReglementByIdFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // 👇 Lettrage: lancer allocation
    allocateAvanceRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    solderImpaye: (state) => {
      state.loading = true;
      state.error = null;
    },
    allocateAvanceSuccess: (state, { payload }) => {
      state.loading = false;
      // payload = AllocationResponse (cf. endpoint)
      // Mettre à jour champ affecté/reglement
      if (state.reglementById && state.reglementById.id === payload.reglementId) {
        state.reglementById.montantAffecte = payload.montantAffecteApres;
        state.reglementById.numBonLivraisons = payload.numerosBLTouchesCsv;
        state.reglementById.statut = payload.statut;
      }
    },
    allocateAvanceFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // 👇 Historique allocations
    getAllocationsByReglementRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getAllocationsByReglementSuccess: (state, payload) => {
      state.loading = false;
      state.allocationHistory = payload || [];
    },
    getAllocationsByReglementFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // Get factures impayees
    getFacturesImpayeesRequest: (state) => {
      state.loading = true;
    },
    avanceClient: (state) => {
      state.loading = true;
    },
    encaisserReglement: (state) => {
      state.loading = true;
      state.error = null;
    },
    annulerReglement: (state) => {
      state.loading = true;
      state.error = null;
    },
    encaisserReglementSuccess: (state, payload) => {
      state.loading = false;
      // Update the payment in the list if it exists there
      const index = state.list.findIndex(item => item.id === payload.id);
      if (index !== -1) {
        state.list[index] = payload;
      }

    },
    encaisserReglementFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // Get bon livraisons non regles
    getBonLivraisonsNonReglesRequest: (state) => {
      state.loading = true;
    },
    getFacturesImpayeesRequest: (state) => {
      state.loading = true;
    },
    getBonLivraisonsNonReglesSuccess: (state, payload) => {
      state.loading = false;
      state.bonLivraisonsNonRegles = payload;
    },
    getBonLivraisonsNonReglesFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    getFacturesImpayeesSuccess: (state, payload) => {
      state.loading = false;
      state.facturesImpayees = payload;
    },
    getFacturesImpayeesFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    finishFetching: (state) => {
      state.loading = false;
    },
    // Add these actions to the reducers object
    linkPaymentsToInvoiceRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    linkPaymentsToInvoiceSuccess: (state, { payload }) => {
      state.loading = false;
      // Update the payments in the list if they exist there
      if (state.list.length > 0) {
        payload.forEach(paymentId => {
          const index = state.list.findIndex(item => item.id === paymentId);
          if (index !== -1) {
            state.list[index].hasInvoice = true;
          }
        });
      }
    },
    linkPaymentsToInvoiceFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
  },
  sagas: (A) => ({
    *[A.listRequest]({ payload }) {
      try {
        const response = yield call(reglementService.getReglements, payload);
        yield put(A.listSuccess(response.data));
      } catch (error) {
        yield put(A.listFailure(error.message));
      }
    },
    *[A.allocationsRequest]({payload}) {
      try {
        const response = yield call(reglementService.getAllocations, payload);
        yield put(A.allocationsSuccess(response.data));
      } catch (error) {
        yield put(A.allocationsFailure(error.message));
      }
    },
    *[A.echeanceClient]({ payload }) {
      try {
        console.log(payload)
        const response = yield call(reglementService.getEcheancesClients, payload);
        console.log(response)
        yield put(A.listEcheanceSuccess(response.data));
      } catch (error) {
        yield put(A.listFailure(error.message));
      }
    },

    *[A.cautionClient]({ payload }) {
      try {
        const response = yield call(reglementService.getCautionsClients, payload);
        yield put(A.listCautionSuccess(response.data));
      } catch (error) {
        yield put(A.listFailure(error.message));
      }
    },

    *[A.encaisserReglement]({ payload }) {
      try {
        const { id, dateEncaissement, onSuccess, onError } = payload;
        const response = yield call(
          reglementService.encaisserReglement,
          id,
          { dateEncaissement: dateEncaissement }
        );
        yield put(A.encaisserReglementSuccess(response.data));
        if (onSuccess) {
          yield call(onSuccess, response.data);
        }
      } catch (error) {
        yield put(A.encaisserReglementFailure(error.message));
        if (payload.onError) {
          yield call(payload.onError, error);
        }
      }
    },

    *[A.annulerReglement]({ payload }) {
      try {
        const { id, onSuccess } = payload;
        yield call(reglementService.annulerReglement, id);
        yield put(A.finishFetching());
        if (onSuccess) {
          yield call(onSuccess);
        }
      } catch (error) {
        yield put(A.encaisserReglementFailure(error.message));
        if (payload.onError) {
          yield call(payload.onError, error);
        }
      }
    },

    *[A.solderImpaye]({ payload }) {
      try {
        yield call(reglementService.solderImpaye, payload.id);
        yield put(A.finishFetching());
        yield call(payload.onSuccess);
      } catch (error) {
        yield put(A.listFailure(error.message));
      }
    },

    *[A.createRequest]({ payload }) {
      try {
        const response = yield call(reglementService.createReglement, payload.data);
        yield put(A.createSuccess(response.data));
        if (payload.onSuccess) {
          payload.onSuccess(response.data);
        }
      } catch (error) {
        yield put(A.createFailure(error.message));
        if (payload.onError) {
          payload.onError(error);
        }
      }
    },

    *[A.getReglementsByInvoiceRequest]({ payload }) {
      try {
        const { numero, onSuccess, onError } = payload;
        const response = yield call(reglementService.getReglementsByInvoice, numero);
        yield put(A.getReglementsByInvoiceSuccess(response.data));
        if (onSuccess) {
          yield call(onSuccess, response.data);
        }
      } catch (error) {
        yield put(A.getReglementsByInvoiceFailure(error.message));
        if (payload.onError) {
          yield call(payload.onError, error);
        }
      }
    },

    *[A.getReglementByIdRequest]({ payload }) {
      try {
        const { data } = yield call(reglementService.getReglementById, payload.id);
        yield put(A.getReglementByIdSuccess(data));
      } catch (e) {
        yield put(A.getReglementByIdFailure(e.message));
      }
    },

    *[A.allocateAvanceRequest]({ payload }) {
      try {
        const { reglementId, onSuccess, onError } = payload;
        const { data } = yield call(reglementService.allocateAvance, reglementId);
        yield put(A.allocateAvanceSuccess(data));
        // Recharger historique + BL non soldés + reglement
        yield put(A.getAllocationsByReglementRequest({ reglementId }));
        yield put(A.getReglementByIdRequest({ id: reglementId }));
        if (onSuccess) onSuccess(data);
      } catch (e) {
        yield put(A.allocateAvanceFailure(e.message));
        if (payload?.onError) payload.onError(e);
      }
    },

    *[A.getAllocationsByReglementRequest]({ payload }) {
      try {
        const { reglementId } = payload;
        const { data } = yield call(reglementService.getAllocationsByReglement, reglementId);
        yield put(A.getAllocationsByReglementSuccess(data));
      } catch (e) {
        yield put(A.getAllocationsByReglementFailure(e.message));
      }
    },

    *[A.updateRequest]({ payload }) {
      try {
        const response = yield call(reglementService.updateReglement, payload.id, payload.data);
        yield put(A.updateSuccess(response.data));
        if (payload.onSuccess) {
          payload.onSuccess();
        }
      } catch (error) {
        yield put(A.updateFailure(error.message));
        if (payload.onError) {
          payload.onError(error);
        }
      }
    },

    *[A.deleteRequest]({ payload }) {
      try {
        yield call(reglementService.deleteReglement, payload.id);
        yield put(A.deleteSuccess(payload.id));
        if (payload.onSuccess) {
          payload.onSuccess();
        }
      } catch (error) {
        yield put(A.deleteFailure(error.message));
        if (payload.onError) {
          payload.onError(error);
        }
      }
    },

    *[A.searchRequest]({ payload }) {
      try {
        const response = yield call(reglementService.rechercherReglements, payload);
        yield put(A.searchSuccess(response.data));
      } catch (error) {
        yield put(A.searchFailure(error.message));
        if (payload.onError) {
          yield call(payload.onError, error);
        }
      }
    },
    *[A.totalsRequest]({ payload }) {
      try {
        const response = yield call(reglementService.rechercherReglementsTotals, payload || {});
        yield put(A.totalsSuccess(response.data));
      } catch (error) {
        yield put(A.totalsFailure(error.message));
        if (payload?.onError) {
          yield call(payload.onError, error);
        }
      }
    },

    *[A.avanceClient]({ payload }) {
      try {
        const response = yield call(reglementService.avanceClient, payload);
        yield put(A.searchSuccess(response.data));
      } catch (error) {
        yield put(A.searchFailure(error.message));
        if (payload.onError) {
          yield call(payload.onError, error);
        }
      }
    },

    *[A.getReglementsByClientRequest]({ payload }) {
      try {
        const { clientId, page, size, sortBy, sortDirection, onSuccess, onError } = payload;
        const response = yield call(
          reglementService.getReglementsByClient,
          clientId,
          page,
          size,
          sortBy,
          sortDirection
        );
        yield put(A.getReglementsByClientSuccess(response.data));
        if (onSuccess) {
          yield call(onSuccess, response.data);
        }
      } catch (error) {
        yield put(A.getReglementsByClientFailure(error.message));
        if (payload.onError) {
          yield call(payload.onError, error);
        }
      }
    },

    *[A.getFacturesImpayeesRequest]({ payload }) {
      try {
        const response = yield call(reglementService.getFacturesImpayees, payload);
        yield put(A.getFacturesImpayeesSuccess(response.data));
      } catch (error) {
        yield put(A.getFacturesImpayeesFailure(error.message));
      }
    },

    *[A.getBonLivraisonsNonReglesRequest]({ payload }) {
      try {
        const response = yield call(reglementService.getBonLivraisonsNonRegles, payload);
        yield put(A.getBonLivraisonsNonReglesSuccess(response.data));
      } catch (error) {
        yield put(A.getBonLivraisonsNonReglesFailure(error.message));
      }
    },
  }),
});

export const reglementActions = reglementModule.actions;
export default reglementModule;
